// pages/ProductList.js
import React, { useEffect, useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import Footer from './includes/Footer';
import "./css/ProductList.css"
import { Slider, Box, Typography } from '@mui/material';
import PageTitle from './includes/PageTitle';

import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from './../firebase/firebaseConfig';
import { CartContext } from './contexts/CartContext';
import { FavoriteContext } from './contexts/FavoriteContext';

function ProductList() {

  const navigate = useNavigate();
  const { 
    category_name, 
    season_name, 
    size_name, 
    gender_name, 
    color_name, 
    sub_category_name, 
    collection_name 
  } = useParams();

  const [filters, setFilters] = useState({
    categoryId: null,
    seasonId: null,
    sizeId: null,
    genderId: null,
    colorId: null,
    subCategoryId: null,
    collectionId: null,
  });

  const decodedFilters = {
    category: decodeURIComponent(category_name || ''),
    season: decodeURIComponent(season_name || ''),
    size: decodeURIComponent(size_name || ''),
    gender: decodeURIComponent(gender_name || ''),
    color: decodeURIComponent(color_name || ''),
    subCategory: decodeURIComponent(sub_category_name || ''),
    collection: decodeURIComponent(collection_name || ''),
  };

  useEffect(() => {
    const fetchFilterIds = async () => {
      try {
        const filterQueries = {
          category: query(collection(db, 'Categories'), where('name', '==', decodedFilters.category)),
          season: query(collection(db, 'Seasons'), where('season_name', '==', decodedFilters.season)),
          size: query(collection(db, 'Sizes'), where('name', '==', decodedFilters.size)),
          gender: query(collection(db, 'Genders'), where('gender_name', '==', decodedFilters.gender)),
          color: query(collection(db, 'Colors'), where('name', '==', decodedFilters.color)),
          subCategory: query(collection(db, 'SubCategories'), where('sub_category_name', '==', decodedFilters.subCategory)),
          collection: query(collection(db, 'Collections'), where('collection_name', '==', decodedFilters.collection)),
        };

        const filterSnapshots = await Promise.all(
          Object.values(filterQueries).map(query => getDocs(query))
        );

        const filterIds = filterSnapshots.reduce((acc, snapshot, index) => {
          if (!snapshot.empty) {
            const doc = snapshot.docs[0];
            const key = Object.keys(filterQueries)[index];
            acc[`${key}Id`] = doc.id;
          }
          return acc;
        }, {});

        setFilters(prev => ({ ...prev, ...filterIds }));
      } catch (error) {
        console.error("Error fetching filter IDs: ", error);
      }
    };

    fetchFilterIds();
  }, [decodedFilters]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const filterConditions = Object.entries(filters)
          .filter(([key, value]) => value) // Include only non-null filters
          .map(([key, value]) => where(key.replace('Id', ''), '==', value)); // Map filter IDs to correct fields

        const productQuery = query(collection(db, 'Products'), ...filterConditions);
        const productSnapshot = await getDocs(productQuery);
        const productsList = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProducts(productsList);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    if (Object.values(filters).some(value => value)) {
      fetchProducts();
    }
  }, [filters]);
  const [value, setValue] = useState([0, 10000000]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { addToCart } = useContext(CartContext);
  const { favorites, addFavorite, removeFavorite } = useContext(FavoriteContext);

  const handleAddToCart = (product) => {
    const item = {
      id: product.id,
      name: product.name,
      price: product.price,
      images: product.images,
      quantity: 1,
      color: product.colors ? product.colors[0] : null,
      size: product.sizes ? product.sizes[0] : null,
    };
    addToCart(item);
  };

  const handleToggleFavorite = (product) => {
    if (favorites.some(item => item.id === product.id)) {
      removeFavorite(product.id);
    } else {
      addFavorite(product);
    }
  };



  const [colors, setColors] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [genders, setGenders] = useState([]);
  const [products, setProducts] = useState([]);
  
  const [selectedFilters, setSelectedFilters] = useState({
    price: [0, 10000000],
    color: [],
    subCategory: '',
    size: '',
    gender: ''
  });

  useEffect(() => {
    const fetchFilters = async () => {
      const colorSnapshot = await getDocs(collection(db, 'Colors'));
      const subCategorySnapshot = await getDocs(collection(db, 'sub_category')); // Capitalized to match Firestore collection
      const sizeSnapshot = await getDocs(collection(db, 'Sizes'));
      const genderSnapshot = await getDocs(collection(db, 'gender')); // Capitalized to match Firestore collection
  
      setColors(colorSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); // Include ID
      setSubCategories(subCategorySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); // Include ID
      setSizes(sizeSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); // Include ID
      setGenders(genderSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))); // Include ID
    };
  
    fetchFilters();
  }, []);

  const handleFilterChange = (filterName, value) => {
    setSelectedFilters(prevState => ({
      ...prevState,
      [filterName]: value
    }));
  };

  const resetFilters = () => {
    setSelectedFilters({
      price: [0, 10000000],
      color: [],
      subCategory: '',
      size: '',
      gender: ''
    });
  };

  const applyFilters = () => {
    console.log('Applying filters:', selectedFilters);
    // Trigger the effect to fetch products with the current filters
    setSelectedFilters(prevFilters => ({
      ...prevFilters
    }));
  };

  useEffect(() => {
    const fetchProducts = async () => {
      let productQuery = collection(db, 'Products');

      if (selectedFilters.price) {
        productQuery = query(productQuery, where('price', '>=', selectedFilters.price[0]), where('price', '<=', selectedFilters.price[1]));
      }
      if (selectedFilters.color.length > 0) {
        productQuery = query(productQuery, where('Color', 'in', selectedFilters.color));
      }
      if (selectedFilters.subCategory) {
        productQuery = query(productQuery, where('sub_category', '==', selectedFilters.subCategory));
      }
      if (selectedFilters.size) {
        productQuery = query(productQuery, where('Sizes', '==', selectedFilters.size));
      }
      if (selectedFilters.gender) {
        productQuery = query(productQuery, where('gender', '==', selectedFilters.gender));
      }

      try {
        console.log('Fetching products with query:', productQuery);
        const productSnapshot = await getDocs(productQuery);
        const fetchedProducts = productSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProducts(fetchedProducts);
        console.log('Fetched products:', fetchedProducts);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    fetchProducts();
  }, [selectedFilters]);


// Pagination func
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12;
   // Calculate the paginated products
   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   const currentProducts = products.slice(indexOfFirstItem, indexOfLastItem);
 
   // Handle page change
   const handlePageChange = (page) => {
     setCurrentPage(page);
   };
 
   const totalPages = Math.ceil(products.length / itemsPerPage);
 
   // loader when coming into the page
   const [loading, setLoading] = useState(true);
   

   useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true); // Start loading
        const querySnapshot = await getDocs(collection(db, "Products"));
        const fetchedProducts = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(fetchedProducts);
         
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchProducts();

    // Ensure the loader shows for 6 seconds
    const timer = setTimeout(() => {
      setLoading(false); // End loading after 6 seconds
    }, 6000);

    // Cleanup timer on component unmount
    return () => clearTimeout(timer);
  }, []);
 
   
  return (
    <>
      <PageTitle title={`${Object.values(decodedFilters).filter(Boolean).join(' - ')} - ALMOSTINVISIBLE`} />
      <div style={{ marginTop: "25vh", marginBottom: "10vh" }}>
        <div className="row">
          <div className="product-list container px-4">
            <h1 className="text-center d-flex justify-content-center unbounded" style={{ margin: "auto", borderBottom: "4px solid black", padding: "1vh .5vw", width: "fit-content" }}>
              {decodedFilters.category || 'Products'}
            </h1>

             {/* products.length > 0 ? (
                <div className="d-flex justify-content-between filter-sort-buttons container py-3">
                <button type="button" className="white-button" data-bs-toggle="modal" data-bs-target="#filterModal">
                  Filter &nbsp;
                  <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.4em" width="1.4em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 16L4 16 10 22 10 19 10 16 10 2 8 2zM14 5L14 8 14 22 16 22 16 8 20 8 14 2z"></path>
                  </svg>
                </button>
              </div>
  
            ) : (
              <div></div>
            )*/}
            
            <div style={{ marginTop: "5vh" }}>
              <div className='prod-box'>
                <div className="container overflow-hidden">
                  <div className="row g-5" style={{ display: "flex", justifyContent: "center" }}>
                  {loading ? (
                      // Loader Component
                      <div className='d-flex justify-content-center flex-column align-items-center'>
                        <div className="spinner-border" style={{ width: "5em", height: "5em" }} role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                        <h5 className="unbounded">
                          Fetching {decodedFilters.category || 'Products'}...
                        </h5>
                      </div>
                    ) : currentProducts.length > 0 ? (
                      currentProducts.map(product => (
                        <div className="col-md-6 col-xl-4 col-sm-6 col-12 p-card-wrap p-0" key={product.id}>
                          <div className="px-3">
                            <Link to={`/p/${product.id}`} className='prod-link'>
                              <div className="p-card">
                                <div className="product-image-container">
                                  <div className="card-image">
                                    <img src={product.images[0]} alt="" />
                                  </div>
                                </div>
                                <div className="p-card-details mt-3 px-3">
                                  <h6 className="fw-bold nunito-2">{product.name}</h6>
                                  <p className='nunito-2'>₦{product.price}</p>
                                </div>
                              </div>
                            </Link>

                            <div className="d-flex justify-content-between align-items-center p-3">
                              <div>
                                  <Link to={`/p/${product.id}`} className='black-bordered-button'>
                                    View
                                  </Link>
                              </div>
                              <div className='d-flex'>
                                    
                                    <button style={{ color: 'white', cursor: 'pointer', backgroundColor: 'black', borderRadius: '50%', padding: '10px', margin: '0 .3vw' }} className="d-flex align-content-center border-rounded" onClick={() => handleAddToCart(product)}>
                                      <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg">
                                        <path fillRule="evenodd" d="M14 5H2v9a1 1 0 001 1h10a1 1 0 001-1V5zM1 4v10a2 2 0 002 2h10a2 2 0 002-2V4H1z" clipRule="evenodd" />
                                        <path d="M8 1.5A2.5 2.5 0 005.5 4h-1a3.5 3.5 0 117 0h-1A2.5 2.5 0 008 1.5z" />
                                      </svg>
                                    </button>
                                    <button className="d-flex justify-content-center align-items-center p-2 border-0" style={{ color: 'black', cursor: 'pointer', backgroundColor: 'white', borderRadius: '50%' }} onClick={() => handleToggleFavorite(product)}>
                                        {favorites.some(item => item.id === product.id) ? (
                                          <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z"></path></svg>
                                            
                                            
                                            
                                        ) : (
                                          <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 1024 1024" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z"></path>
                                            </svg>
                                        )}
                                    </button>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                       ))
                      ) : (
                      <div className='d-flex justify-content-center flex-column'>
                        <div>
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="7em" width="7em" xmlns="http://www.w3.org/2000/svg"><g><path fill="none" d="M0 0h24v24H0z"></path><path d="M12 2c5.523 0 10 4.477 10 10a9.958 9.958 0 0 1-1.065 4.496 1.977 1.977 0 0 0-.398-.775l-.123-.135L19 14.172l-1.414 1.414-.117.127a2 2 0 0 0 1.679 3.282A9.974 9.974 0 0 1 12 22C6.477 22 2 17.523 2 12S6.477 2 12 2zm0 13c-1.38 0-2.63.56-3.534 1.463l-.166.174.945.86C10.035 17.182 10.982 17 12 17c.905 0 1.754.144 2.486.396l.269.1.945-.86A4.987 4.987 0 0 0 12 15zm-3.5-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm7 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"></path></g></svg>                    

                        </div>
                        <h1 className="unbounded">
                          Sorry, we are currently out of stock for this category. 
                        </h1><hr />
                        <h6 className="unbounded">
                          Don't worry, we will get back to you soon!
                        </h6>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>

    {/* Pagination Controls */}
    {totalPages > 1 && (
              <div className="pagination-container d-flex justify-content-center mt-4">
                {[...Array(totalPages).keys()].map(pageNumber => (
                  <button
                    key={pageNumber + 1}
                    className={`pagination-button ${currentPage === pageNumber + 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(pageNumber + 1)}
                  >
                    {pageNumber + 1}
                  </button>
                ))}
              </div>
            )}

            
      <div class="modal fade" id="filterModal">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title unbounded">Filter By:</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
      <form action="#" method="get">
                <div className="form-group">
                  <Box sx={{ width: '100%', margin: '0', padding: '20px' }}>
                    <p className="unbounded h6">Price:</p>
                    <Slider
                      value={selectedFilters.price}
                      onChange={(e, value) => handleFilterChange('price', value)}
                      valueLabelDisplay="auto"
                      min={0}
                      max={10000000}
                      sx={{
                        color: 'black',
                        '& .MuiSlider-thumb': { color: 'black' },
                        '& .MuiSlider-track': { color: 'black' },
                        '& .MuiSlider-rail': { color: 'black' },
                      }}
                    />
                    <Box display="flex" justifyContent="space-between">
                      <Typography>₦{selectedFilters.price[0]}</Typography>
                      <Typography>₦{selectedFilters.price[1]}</Typography>
                    </Box>
                  </Box>
                </div>
                <hr />

                <div className="form-group">
                  <p className="unbounded h6">Color:</p>
                  <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
                    {colors.map((color, index) => (
                      <Box
                        key={index}
                        onClick={() => handleFilterChange('color', color.label)}
                        sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
                      >
                        <Box sx={{ backgroundColor: color.color, width: 20, height: 20, borderRadius: '50%', border: '1px solid #ccc' }} />
                        <Typography variant="body2">{color.name}</Typography>
                      </Box>
                    ))}
                  </Box>
                </div>
                <hr />

                <div className="form-group">
                  <p className="unbounded h6">Sub-Category:</p>
                  <div className="row mt-4" style={{ gap: "15px" }}>
                    {subCategories.map((subCategory, index) => (
                      <button
                        key={index}
                        className="white-button nunito-2 col- fw-bold"
                        style={{ fontSize: "18px" }}
                        onClick={() => handleFilterChange('subCategory', subCategory.name)}
                      >
                        {subCategory.sub_category_name}
                      </button>
                    ))}
                  </div>
                </div>
                <hr />

                <div className="form-group">
                  <p className="unbounded h6">Sizes:</p>
                  <div className="row mt-4" style={{ gap: "15px" }}>
                    {sizes.map((size, index) => (
                      <button
                        key={index}
                        className="white-button nunito-2 col- fw-bold"
                        style={{ fontSize: "18px" }}
                        onClick={() => handleFilterChange('size', size.name)}
                      >
                        {size.name}
                      </button>
                    ))}
                  </div>
                </div>
                <hr />

                <div className="form-group">
                  <p className="unbounded h6">Gender:</p>
                  <div className="row mt-4" style={{ gap: "15px" }}>
                    {genders.map((gender, index) => (
                      <button
                        key={index}
                        className="white-button nunito-2 col- fw-bold"
                        style={{ fontSize: "18px" }}
                        onClick={() => handleFilterChange('gender', gender.name)}
                      >
                        {gender.gender_name}
                      </button>
                    ))}
                  </div>
                </div>
                <hr />

                <div className="d-flex justify-content-end">
                  <button type="button" className="btn btn-secondary me-2" onClick={resetFilters}>Reset</button>
                  <button type="button" className="btn btn-primary" onClick={applyFilters} data-bs-dismiss="modal">Apply</button>
                </div>
              </form>
      </div>
    </div>
  </div>
      </div>


    <Footer />
</>
  );
}

export default ProductList;
